import React, { Dispatch, SetStateAction } from "react";
import {
  DailyTransactionTypeEnum,
  ItemDiscountValuesModel,
  LookupItemModel,
  PriceTypeEnum,
  TransactionDetailResponseModel,
  TransactionItemResponseModel,
  UserTransactionsSettingResponseModel,
   RowStateEnum, UserConfigurationModel
} from "../../../../models";
import _ from "lodash";
import {
  handleCalculateItemRecordValuesUpdate,
  handleTransactionTotalValues,
} from "./transactionBl";
import {generateGuid, getOriginalValueInCurrency,  handleError, roundNumber} from "../../../../utils";
//#region post
export const UpdateTransactionItemStateOnChange = async (
  setState: Dispatch<SetStateAction<TransactionDetailResponseModel>>,
  stateValue: TransactionDetailResponseModel,
  request: TransactionItemResponseModel
) => {
  let obj: TransactionItemResponseModel[] =
    stateValue.TransactionDetaillist.map((row) => {
      if (row.rowKey == request.rowKey && row.rowState === request.rowState) {
        const rowState = row.rowState === RowStateEnum.Add ? row.rowState : RowStateEnum.Update;
        return {...request, rowState};
      } else {
        return row;
      }
    });
  setState({
    ...stateValue,
    TransactionDetaillist: obj,
  });
};
//#endregion
//#region calculations
export const handleCalculateExistItemValuesChange = async (
  setState: Dispatch<SetStateAction<TransactionDetailResponseModel>>,
  stateValue: TransactionDetailResponseModel,
  request: TransactionItemResponseModel,
) => {
  let obj: TransactionItemResponseModel[] = _.map(
    stateValue.TransactionDetaillist,
    (row) => {
      if (row.rowKey == request.rowKey && row.rowState === request.rowState) {
        request.latestModifiedDate = new Date();
        request = handleCalculateItemRecordValuesUpdate(request);
        return request;
      } else {
        return row;
      }
    }
  );
  const stateObject = handleTransactionTotalValues({
    ...stateValue,
    TransactionDetaillist: obj,
  });
  setState({
    ...stateObject,
    TransactionDetaillist: obj,
  });
};
export const calculateItemDiscount = (
  request: TransactionItemResponseModel
): ItemDiscountValuesModel => {
  let response: ItemDiscountValuesModel = {
    ItemDiscount: 0,
    ItemDiscountInCurrency: 0,
  };
  let discountValue: number = request.ItemDiscount || 0;
  let discountValueInCurrency: number = request.ItemDiscountInCurrency || 0;
  const itemPrice: number = (request.Quantity || 0) * (request.Unit_Price || 0);
  const itemPriceInCurrency: number =
    (request.Quantity || 0) * (request.Unit_PriceInCurrencyCalculated || 0);
  discountValue =
    request.ItemDiscountRatio != 0
      ? (itemPrice * (request.ItemDiscountRatio || 0)) / 100
      : discountValue;
  discountValueInCurrency =
    request.ItemDiscountRatio != 0
      ? (itemPriceInCurrency * (request.ItemDiscountRatio || 0)) / 100
      : discountValueInCurrency;
  //response.ItemDiscount = roundNumber(discountValue);
  response.ItemDiscountInCurrency = roundNumber(discountValueInCurrency);
  response.ItemDiscount=response.ItemDiscountInCurrency!=0?getOriginalValueInCurrency(request.ItemDiscountInCurrency,request.ValueOfCurrency):0;
  return response;
  //return RoundNumber(value)
};
export const calculateItemUnitPriceOrPriceWithTax = (
  value: number,
  itemTaxPercentage: number,
  isTaxCalculation: boolean
): number => {
  const fixedValue: number = 100;
  return isTaxCalculation
    ? roundNumber((value * itemTaxPercentage) / fixedValue + Number(value))
    : roundNumber(
        value -
          (itemTaxPercentage * value) /
            (fixedValue + Number(itemTaxPercentage)),
        2
      );
};
export const calculateItemTax = (
  request: TransactionItemResponseModel
): number => {
  let taxValue: number;
  try {
    taxValue =
      request.TaxPercentge > 0
        ? roundNumber(
            Number(
              (request.TaxPercentge *
                (request.Unit_Price -
                  request.ItemDiscount / request.Quantity)) /
                100
            )
          )
        : 0;
  } catch (e: any) {
    alert(handleError(e));
    taxValue = 0;
  }
  return taxValue;
};
export const calculateItemPrice = (
  request: TransactionItemResponseModel
): number => {

  let value: number;
  if (request.UnitPriceWithTaxCalculated != null && request.UnitPriceWithTaxCalculated !== 0) {
    value =  request.Quantity * request.UnitPriceWithTaxCalculated;
  } else {
    // Fallback to original calculation
    value = request.Quantity * request.Unit_Price;
    value += request.TotalTax ?? 0;
  }

  // Apply discount if present
  if (request.ItemDiscount != null && request.ItemDiscount !== 0) {
    value -= request.ItemDiscount;
  }

  // Round final result before returning
  return roundNumber(value);
  // let value: number = request.Quantity * request.Unit_Price;
  // value = value + request.TotalTax;
  // value = request.ItemDiscount !== 0 ? value - request.ItemDiscount : value;
   //return roundNumber(value);
};

export const calculateItemPriceInCurrency = (
    request: TransactionItemResponseModel
): number => {

  // Step 1: Calculate subtotal (before tax) = Unit Price * Quantity - Discount

  const quantity = request.Quantity ?? 0;
  const itemDiscountInCurrency = request.ItemDiscountInCurrency ?? 0;

  //Case 1: No discount → use UnitPriceWithTaxInCurrency * Quantity
  if (!itemDiscountInCurrency || itemDiscountInCurrency === 0) {
    const unitPriceWithTax = request.UnitPriceWithTaxInCurrency ?? 0;
    return roundNumber(unitPriceWithTax * quantity);
  }
  //Case 2: Discount exists → use original tax calculation logic
  const unitPriceInCurrency = request.Unit_PriceInCurrencyCalculated ?? 0;
  const subtotalBeforeTax = (unitPriceInCurrency * quantity) - itemDiscountInCurrency;
  // Step 2: Calculate tax amount based on TaxPercentage
  const taxPercentage = request.TaxPercentge ?? 0;
  const taxAmount = subtotalBeforeTax * (taxPercentage / 100);

  // Step 3: Final item price = subtotal + tax
  const totalItemPrice = subtotalBeforeTax + taxAmount;

  return roundNumber(totalItemPrice);
};

//#endregion
//#region item
export const handleGroupItemsBasedOnId = (
  request: TransactionItemResponseModel[],
  item: TransactionItemResponseModel,
  userConfiguration: UserConfigurationModel
): TransactionItemResponseModel[] => {
  if (request === null || request === undefined || request.length === 0) {
    request = [];
  }
  if(userConfiguration?.userSetting?.AddItemInNewLineInBill){
    // const newItem = {
    //   ...item,
    //   rowKey: generateGuid(), // Generate a unique GUID for the new entry
    //   rowState: RowStateEnum.Add
    // };
    // request = [...request, newItem];
    request.push({...item,rowKey:generateGuid(),rowState:Number(RowStateEnum.Add)});
    return request;
  }

  const index = _.findIndex(request, { ItemUnit_ID: item.ItemUnit_ID });
  if (index !== -1) {
    request[index] = item;
  } else {
    request.push(item);
  }
  return request;
};
export const getItemSalesPrice = (
  id: number,
  transactionType: DailyTransactionTypeEnum,
  calcType: number | null,
  itemList: LookupItemModel[],
  calcTypeList: LookupItemModel[],
  userTransactionSetting: UserTransactionsSettingResponseModel
  //transactionObject:TransactionDetailResponseModel
): number => {
  if (id === 0) {
    return 0;
  }

  // @ts-ignore
  const calcTypeRecord: LookupItemModel =
    calcType !== null && calcType !== undefined && calcType !== 0
      ? calcTypeList.filter((p) => p.value === calcType.toString())[0]
      : calcTypeList.filter(
          (p) => p.value === userTransactionSetting.DefaultCalcTypeID.toString()
        )[0];
  let price: number = 0;
  const item = itemList.filter(
    //@ts-ignore
    (p) => p.value === id.toString()
  )[0];
  try {
    let transactionCalcType: number = 0;
    //transactionCalcType = calcTypeRecord.otherValue.priceType;
    if (
      transactionCalcType === Number(PriceTypeEnum.DefaultPrice) ||
      Number(transactionCalcType === PriceTypeEnum.None)
    ) {
      try {
        transactionCalcType = Number(
          calcTypeList.filter(
            (p) =>
              p.value === userTransactionSetting.DefaultCalcTypeID.toString()
          )[0].otherValue.priceType
        );
      } catch (e) {
        transactionCalcType = Number(PriceTypeEnum.DefaultPrice);
      }
    }
    switch (transactionCalcType) {
      case Number(PriceTypeEnum.PriceSale):
        switch (transactionType) {
          case DailyTransactionTypeEnum.SalesInvoice:
          case DailyTransactionTypeEnum.SalesRefund:
          case DailyTransactionTypeEnum.POSSales:
          case DailyTransactionTypeEnum.POSSalesRefund:
          case DailyTransactionTypeEnum.POSRestaurant:
          case DailyTransactionTypeEnum.Reserve_Restaurant_Bill:
          case DailyTransactionTypeEnum.ReturnPOSRestaurant:
          case DailyTransactionTypeEnum.ShowPrice:
            price = item.otherValue.sellPrice;
            break;
          case DailyTransactionTypeEnum.PurchasesInvoice:
          case DailyTransactionTypeEnum.PurchasesRefund:
            price = item.otherValue.purchasePrice;
            break;
          case DailyTransactionTypeEnum.MoveToStore:
          case DailyTransactionTypeEnum.ReceiveFromStore:
            price = item.otherValue.sellPrice;
            break;
        }
        break;
      case Number(PriceTypeEnum.PriceCost):
        price = item.otherValue.costPrice;
        break;
      case Number(PriceTypeEnum.PricePurchase):
        price = item.otherValue.purchasePrice;
        break;
      case Number(PriceTypeEnum.WholeSalePrice):
        price = item.otherValue.wholeSalePrice;
        break;
      case Number(PriceTypeEnum.AdditionalPrice):
        price = item.otherValue.additionalPrice;
        break;
      case Number(PriceTypeEnum.DefaultPrice):
      default:
        price = item.otherValue.sellPrice;
        break;
    }
    price = price === null || price === undefined ? 0 : price;
    price =
      Number(price) +
      Number(price) * (Number(calcTypeRecord.otherValue.percentage) / 100);
  } catch (e: any) {
    alert(handleError("error occurred while getItemSalesPrice please contact support" + e));
  }
  return price === null || price === undefined ? 0 : price;
};
export const getItemInStoreId = (
  itemUnitId: number | null,
  itemList: LookupItemModel[]
): number | null => {
  let value: number | null = null;
  if (itemUnitId !== null && itemUnitId !== undefined) {
    const item = itemList.filter(
      //@ts-ignore
      (p) => p.value === itemUnitId.toString()
    )[0];
    return item !== null &&
      item !== undefined &&
      item.otherValue != null &&
      item.otherValue.itemInStoreId !== null
      ? Number(item.otherValue.itemInStoreId)
      : null;
  }
  return value;
};
//#endregion
//#region common
export const updateSelectBox = (
    ref: React.MutableRefObject<any>,
    value: any
) => {
  if (value != null) {
    ref.current?.setValue(value);
  } else {
    ref.current?.clearValue();
  }
};
export const isConfiguredForSavePurchaseFromTransactionByTransactionType = (configurations: UserConfigurationModel) =>
    (transactionType: DailyTransactionTypeEnum): boolean => {
      if (!configurations?.genericSystemConfiguration) {
        return false;
      }

      return configurations.genericSystemConfiguration.IsSavePurchaseTransactionFromSalesForBalanceLessTHanZero && Array.isArray(configurations.genericSystemConfiguration.TransactionTypeIdsConfigureToSavePurchaseFromTransaction) &&
          configurations.genericSystemConfiguration.TransactionTypeIdsConfigureToSavePurchaseFromTransaction.includes(transactionType);
    };

export const isConfiguredForSavePurchaseFromTransaction = (
    transactionType: DailyTransactionTypeEnum,
    configurations: UserConfigurationModel
): boolean =>
    !!configurations?.genericSystemConfiguration?.IsSavePurchaseTransactionFromSalesForBalanceLessTHanZero &&
    Array.isArray(configurations?.genericSystemConfiguration?.TransactionTypeIdsConfigureToSavePurchaseFromTransaction) &&
    configurations.genericSystemConfiguration.TransactionTypeIdsConfigureToSavePurchaseFromTransaction.includes(transactionType);
//#endregion